import { LitElement as f, unsafeCSS as d } from "lit";
import { property as t } from "lit/decorators.js";
import h from "../../shared/reset.style.css.js";
import { booleanType as s } from "../../utils/property-types.js";
import u from "./button.style.css.js";
import { template as c } from "./button.template.js";
var m = Object.defineProperty, e = (l, i, p, n) => {
  for (var r = void 0, a = l.length - 1, y; a >= 0; a--)
    (y = l[a]) && (r = y(i, p, r) || r);
  return r && m(i, p, r), r;
};
class o extends f {
  constructor() {
    super(...arguments), this.type = "button", this.variant = "primary", this.status = "default", this.label = "", this.icon = void 0, this.iconPosition = "left", this.disabled = !1, this.hidden = !1, this.onlyIcon = !1, this.fullWidth = !1, this.size = "md", this.tooltipFixed = !1, this.loading = !1, this.forceViewport = !1, this.tooltipPosition = "top", this.loadingIcon = "progress_activity";
  }
  static get styles() {
    return [d(h), d(u)];
  }
  _handleClick() {
    if (this.disabled || this.loading) return;
    const i = this.closest("form");
    this.type === "submit" && i ? i.requestSubmit() : this.type === "reset" && i && i.reset(), this.dispatchEvent(new CustomEvent("onClick", { bubbles: !0, composed: !0 }));
  }
  _getIconSize() {
    return this.size === "lg" ? "md" : "sm";
  }
  checkTextTruncate(i) {
    if (!i) return;
    const p = i.target;
    let n = !1;
    if (this.onlyIcon)
      n = !0;
    else {
      const r = p.querySelector(".dss-button-text");
      n = r.scrollWidth > r.offsetWidth;
    }
    p.setAttribute("data-truncated", n.toString());
  }
  render() {
    return c(this);
  }
}
e([
  t({ type: String })
], o.prototype, "type");
e([
  t({ type: String })
], o.prototype, "variant");
e([
  t({ type: String })
], o.prototype, "status");
e([
  t({ type: String })
], o.prototype, "label");
e([
  t({ type: String })
], o.prototype, "icon");
e([
  t({ type: String })
], o.prototype, "iconPosition");
e([
  t(s)
], o.prototype, "disabled");
e([
  t(s)
], o.prototype, "hidden");
e([
  t(s)
], o.prototype, "onlyIcon");
e([
  t(s)
], o.prototype, "fullWidth");
e([
  t({ type: String })
], o.prototype, "size");
e([
  t(s)
], o.prototype, "tooltipFixed");
e([
  t(s)
], o.prototype, "loading");
e([
  t(s)
], o.prototype, "forceViewport");
e([
  t({ type: String })
], o.prototype, "tooltipPosition");
export {
  o as Button
};
//# sourceMappingURL=button.js.map
